module.exports = __webpack_public_path__ + "static/media/view_checkin_desktop.c2577075.jpg";